export default "__VITE_ASSET__BtMcgrBo__"